import { formatTimeWithMilliseconds } from '../../../common/common.utils'
import videojs from 'video.js'
import Player from 'video.js/dist/types/player'
import styles from '../VideoPlayer.module.less'

export class SegmentTimeWithMilliseconds extends videojs.getComponent('Component') {
    constructor(player: Player, options: object) {
        super(player, options)
        this.player().on('timeupdate', () => this.updateContent())
        this.player().on('segmentchange', () => this.updateContent())
    }

    getContent() {
        const currentTime = this.player().currentTime() ?? 0
        // @ts-ignore
        const segment = this.player().segment_ || null

        if (segment && segment.startTime !== undefined && segment.endTime !== undefined) {
            const clampedCurrentTime = Math.max(
                segment.startTime,
                Math.min(currentTime, segment.endTime)
            )
            return {
                currentTime: formatTimeWithMilliseconds(clampedCurrentTime),
                startTime: formatTimeWithMilliseconds(segment.startTime),
                endTime: formatTimeWithMilliseconds(segment.endTime),
            }
        }

        const duration = Number.isNaN(this.player().duration() ?? 0) ? 0 : this.player().duration()
        return {
            currentTime: formatTimeWithMilliseconds(currentTime),
            startTime: formatTimeWithMilliseconds(0),
            endTime: formatTimeWithMilliseconds(duration ?? 0),
        }
    }

    createEl() {
        const el = videojs.dom.createEl('div', { className: styles['vjs-time-milliseconds'] })
        const { currentTime, endTime } = this.getContent()

        const currentTimeEl = videojs.dom.createEl('span', {
            className: styles['current-video-time'],
            innerHTML: currentTime,
        })
        const separator = videojs.dom.createEl('span', {
            className: styles['separator'],
            innerHTML: '/',
        })
        const endTimeEl = videojs.dom.createEl('span', {
            className: styles['end-time'],
            innerHTML: endTime,
        })

        el.appendChild(currentTimeEl)
        el.appendChild(separator)
        el.appendChild(endTimeEl)
        return el
    }

    updateContent() {
        const { currentTime, endTime } = this.getContent()
        const children = this.el().children

        ;(children[0] as HTMLElement).innerText = currentTime
        ;(children[2] as HTMLElement).innerText = endTime
    }
}
